import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FileComplain from "./fileComplain";
import {
  locationCity,
  locationZone,
  locationArea,
} from "services/redux/sales/corporate/locations/action";
import {
  getSiteTypes,
  getSiteInformation
} from "services/redux/fileComplain/action"

const mapStateToProps = (state) => ({
  cities: state.locationReducer.cities,
  zones: state.locationReducer.zones,
  areas: state.locationReducer.areas,
  siteTypes: state.fileComplainReducer.siteTypes,
  siteInfo: state.fileComplainReducer.siteInfo,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    getSiteInformation,
    locationCity,
    locationZone,
    locationArea,
    getSiteTypes,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FileComplain);
